// extracted by mini-css-extract-plugin
export default {"questionText":"questionText_WordCloudHOC-module_eq06_","wordCloudContainer":"wordCloudContainer_WordCloudHOC-module_WI4Ef"};